var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('AlertMessage',{staticClass:"mb-4",attrs:{"type":"warning","message":_vm.status}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }